import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../pages/authentication/Index';

const Login = lazy(() => import('../pages/authentication/overview/SignIn'));
const VerifyOTP = lazy(() => import('../pages/authentication/overview/Verify-otp'));

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="/verify-otp" element={<VerifyOTP />} />
      <Route path="*" element={<AuthRoot />} />
    </Routes>
  );
});

FrontendRoutes.displayName = 'FrontendRoutes';
export default AuthLayout(FrontendRoutes);
